import React, { Component } from "react";
import PropTypes from "prop-types";
import { stateToHTML } from "draft-js-export-html";
import { convertToRaw } from "draft-js";
import { draftToMarkdown } from "markdown-draft-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { detect } from "detect-browser";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import JobOptionsButton from "./JobOptionsButton";
import CurrentComponent from "./CurrentComponent";
import FormStepsButtons from "./FormStepsButtons";
import Button from "../shared/button/Button";
import Saving from "../shared/loaders/Saving";
import feedbackTimescaleOptionsType from "./types/feedbackTimescaleOptionsType";
import sectorOptionsType from "./types/sectorOptionsType";
import notificationRecipientsType from "./types/notificationRecipientsType";
import audienceMembersType from "./types/audienceMembersType";
import vacancyReasonOptionsType from "./types/vacancyReasonOptionsType";
import errorsType from "./types/errorsType";
import {
  Wrapper,
  ModalBackdrop,
  EditModalWrapper,
  Title,
  TitleText,
  CloseButton,
  Form,
  CurrentComponentWrapper,
  ButtonsWrapper,
} from "./styles/edit-form-styles";

class EditForm extends Component {
  constructor(props) {
    super(props);
    const {
      agencyBriefing,
      audienceMemberIds,
      audienceMembers,
      benefitIds,
      burst,
      considerRelocation,
      contractDuration,
      contractDurationInterval,
      currencyId,
      currencySymbol,
      cvLimitPerRecruiter,
      degreeRequired,
      description,
      feedbackTimescaleId,
      feedbackTimescaleOptions,
      interviewComments,
      interviewStages,
      jobTitle,
      jobType,
      keySkills,
      location,
      notificationRecipientIds,
      notificationRecipients,
      postcode,
      recruiterFeePercentage,
      salaryMax,
      salaryMin,
      salaryRange,
      salaryType,
      sectorId,
      vacancyReason,
      visaSponsorship,
      numberOfPositions,
    } = this.props;

    this.state = {
      agencyBriefing,
      audienceMemberIds,
      audienceMembers,
      benefitIds,
      isLiveOnTheMarketplace: burst,
      burst,
      considerRelocation,
      contractDuration,
      contractDurationInterval,
      currencyId,
      currencySymbol,
      cvLimitPerRecruiter,
      degreeRequired,
      description,
      feedbackTimescaleId,
      feedbackTimescaleOptions,
      interviewComments,
      interviewStages,
      jobTitle,
      jobType,
      keySkills,
      location,
      notificationRecipientIds,
      notificationRecipients,
      postcode,
      recruiterFeePercentage,
      salaryMax,
      salaryMin,
      salaryRange,
      salaryType,
      sectorId,
      vacancyReason,
      visaSponsorship,
      numberOfPositions,
    };
  }

  feedbackTimescaleOnChange = (e) => {
    this.setState({ [e.target.name]: Number(e.target.value) });
  };

  inputOnChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  jobTypeOnChange = (e) => {
    this.setState({ jobType: e.target.id });
  };

  salaryTypeOnChange = (e) => {
    this.setState({ salaryType: e.target.id });
  };

  burstOnChange = (e) => {
    if (e.target.id === "yes") {
      this.setState({ burst: true });
    }
    if (e.target.id === "no") {
      this.setState({ burst: false });
    }
  };

  checkBoxOnChange = (e) => {
    if (e.target.checked) {
      this.setState({ [e.target.name]: true });
    } else {
      this.setState({ [e.target.name]: false });
    }
  };

  editorOnChange = (editorState) => {
    let html = stateToHTML(editorState.getCurrentContent());
    if (html === "<p><br></p>") {
      html = "";
    }
    this.setState({ description: html });
  };

  agencyBriefingOnChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const markdown = draftToMarkdown(convertToRaw(contentState));
    this.setState({ agencyBriefing: markdown });
  };

  benefitsOnChange = (e) => {
    const { benefitIds } = this.state;
    let newBenefits;
    if (e.target.checked) {
      newBenefits = benefitIds.concat(Number(e.target.id));
    } else {
      newBenefits = benefitIds.filter(
        (benefit) => benefit !== Number(e.target.id)
      );
    }

    this.setState({ benefitIds: newBenefits });
  };

  notificationRecipientsOnChange = (value) => {
    const newRecipients = value.map((recipient) => recipient.value);
    this.setState({
      notificationRecipientIds: newRecipients,
    });
  };

  audienceMembersOnChange = (value) => {
    let newMembers = value.map((member) => member.value);
    if (newMembers.includes("")) {
      newMembers = [""];
    }

    this.setState({
      audienceMemberIds: newMembers,
    });
  };

  mustHavesOnChange = (tags) => {
    const newMustHaves = tags.join(",");
    this.setState({ keySkills: newMustHaves });
  };

  handleSubmit = (e) => {
    const { updateJobProfile, audienceId } = this.props;
    const {
      agencyBriefing,
      benefitIds,
      considerRelocation,
      contractDuration,
      contractDurationInterval,
      cvLimitPerRecruiter,
      degreeRequired,
      description,
      feedbackTimescaleId,
      feedbackTimescaleOptions,
      interviewComments,
      interviewStages,
      jobTitle,
      jobType,
      keySkills,
      location,
      postcode,
      notificationRecipientIds,
      notificationRecipients,
      recruiterFeePercentage,
      salaryMax,
      salaryMin,
      salaryRange,
      salaryType,
      sectorId,
      vacancyReason,
      visaSponsorship,
      audienceMemberIds,
      audienceMembers,
      burst,
      numberOfPositions,
      currencyId,
    } = this.state;

    e.preventDefault();
    updateJobProfile({
      agencyBriefing,
      audienceId,
      benefitIds,
      considerRelocation,
      contractDuration,
      contractDurationInterval,
      cvLimitPerRecruiter,
      degreeRequired,
      description,
      feedbackTimescaleId,
      feedbackTimescaleOptions,
      interviewComments,
      interviewStages,
      jobTitle,
      jobType,
      keySkills,
      location,
      postcode,
      notificationRecipientIds,
      notificationRecipients,
      recruiterFeePercentage,
      salaryMax,
      salaryMin,
      salaryRange,
      salaryType,
      sectorId,
      vacancyReason,
      visaSponsorship,
      audienceMemberIds,
      audienceMembers,
      burst,
      numberOfPositions,
      currencyId,
    });

    if (burst) {
      this.setState({ isLiveOnTheMarketplace: true });
    }
  };

  handleValidation = () => {
    const { validate, audienceId } = this.props;
    const {
      agencyBriefing,
      benefitIds,
      considerRelocation,
      contractDuration,
      contractDurationInterval,
      currencySymbol,
      cvLimitPerRecruiter,
      degreeRequired,
      description,
      feedbackTimescaleId,
      feedbackTimescaleOptions,
      interviewComments,
      interviewStages,
      jobTitle,
      jobType,
      keySkills,
      location,
      postcode,
      notificationRecipientIds,
      notificationRecipients,
      recruiterFeePercentage,
      salaryMax,
      salaryMin,
      salaryRange,
      salaryType,
      sectorId,
      vacancyReason,
      visaSponsorship,
      audienceMemberIds,
      audienceMembers,
      burst,
      numberOfPositions,
      currencyId,
    } = this.state;

    return validate({
      agencyBriefing,
      audienceId,
      benefitIds,
      considerRelocation,
      contractDuration,
      contractDurationInterval,
      currencySymbol,
      cvLimitPerRecruiter,
      degreeRequired,
      description,
      feedbackTimescaleId,
      feedbackTimescaleOptions,
      interviewComments,
      interviewStages,
      jobTitle,
      jobType,
      keySkills,
      location,
      postcode,
      notificationRecipientIds,
      notificationRecipients,
      recruiterFeePercentage,
      salaryMax,
      salaryMin,
      salaryRange,
      salaryType,
      sectorId,
      vacancyReason,
      visaSponsorship,
      audienceMemberIds,
      audienceMembers,
      burst,
      numberOfPositions,
      currencyId,
    });
  };

  handleReset = () => {
    this.setState(this.props);
  };

  onKeyPress = (event) => {
    if (event.which === 13) {
      event.preventDefault();
    }
  };

  render() {
    const { jobTitle, isLiveOnTheMarketplace } = this.state;
    const iOS = detect().name === "ios";
    const {
      applicationsAtOfferOrAccepted,
      sectorOptions,
      vacancyReasonOptions,
      currencyOptions,
      errors,
      handleModalShow,
      handlePrev,
      handleNext,
      loading,
      editModalActive,
      step,
      copyJobUrl,
      closeJobUrl,
      isJobActive,
      isPortalEmployer,
      jobStatus,
    } = this.props;

    return (
      <Wrapper>
        <JobOptionsButton
          applicationsAtOfferOrAccepted={applicationsAtOfferOrAccepted}
          handleModalShow={handleModalShow}
          copyJobUrl={copyJobUrl}
          closeJobUrl={closeJobUrl}
          isJobActive={isJobActive}
          jobStatus={jobStatus}
        />
        {editModalActive && (
          <ModalBackdrop>
            <EditModalWrapper iOS={iOS} data-test-id="job-profile-edit-form">
              {loading && <Saving white />}
              <Title>
                <TitleText>Edit {jobTitle} Job</TitleText>
                <CloseButton
                  onClick={(e) => {
                    this.handleReset();
                    handleModalShow(e);
                  }}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </CloseButton>
              </Title>
              <Form
                onSubmit={this.handleSubmit}
                iOS={iOS}
                onKeyPress={this.onKeyPress}
              >
                <FormStepsButtons
                  step={step}
                  handlePrev={handlePrev}
                  handleNext={handleNext}
                  handleValidation={this.handleValidation}
                  isPortalEmployer={isPortalEmployer}
                />
                <CurrentComponentWrapper iOS={iOS}>
                  <CurrentComponent
                    step={step}
                    jobProfile={this.state}
                    sectorOptions={sectorOptions}
                    vacancyReasonOptions={vacancyReasonOptions}
                    currencyOptions={currencyOptions}
                    inputOnChange={this.inputOnChange}
                    jobTypeOnChange={this.jobTypeOnChange}
                    salaryTypeOnChange={this.salaryTypeOnChange}
                    editorOnChange={this.editorOnChange}
                    agencyBriefingOnChange={this.agencyBriefingOnChange}
                    checkBoxOnChange={this.checkBoxOnChange}
                    benefitsOnChange={this.benefitsOnChange}
                    feedbackTimescaleOnChange={this.feedbackTimescaleOnChange}
                    notificationRecipientsOnChange={
                      this.notificationRecipientsOnChange
                    }
                    audienceMembersOnChange={this.audienceMembersOnChange}
                    burstOnChange={this.burstOnChange}
                    mustHavesOnChange={this.mustHavesOnChange}
                    isPortalEmployer={isPortalEmployer}
                    isLiveOnTheMarketplace={isLiveOnTheMarketplace}
                    errors={errors}
                  />
                </CurrentComponentWrapper>
                <ButtonsWrapper iOS={iOS}>
                  <Button
                    iOS={iOS}
                    secondary
                    buttonName="Cancel"
                    onClickAction={(e) => {
                      this.handleReset();
                      handleModalShow(e);
                    }}
                  />
                  <Button primary iOS={iOS} buttonName="Save" type="submit" />
                </ButtonsWrapper>
              </Form>
            </EditModalWrapper>
          </ModalBackdrop>
        )}
      </Wrapper>
    );
  }
}

EditForm.propTypes = {
  agencyBriefing: PropTypes.string,
  applicationsAtOfferOrAccepted: PropTypes.bool.isRequired,
  audienceId: PropTypes.number,
  audienceMemberIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  audienceMembers: audienceMembersType.isRequired,
  benefitIds: PropTypes.arrayOf(PropTypes.number),
  burst: PropTypes.bool,
  closeJobUrl: PropTypes.string,
  considerRelocation: PropTypes.bool.isRequired,
  contractDuration: PropTypes.number,
  contractDurationInterval: PropTypes.string,
  copyJobUrl: PropTypes.string,
  currencySymbol: PropTypes.string,
  cvLimitPerRecruiter: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  degreeRequired: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  editModalActive: PropTypes.bool.isRequired,
  errors: errorsType.isRequired,
  feedbackTimescaleId: PropTypes.number.isRequired,
  feedbackTimescaleOptions: feedbackTimescaleOptionsType.isRequired,
  handleModalShow: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handlePrev: PropTypes.func.isRequired,
  interviewComments: PropTypes.string,
  interviewStages: PropTypes.number.isRequired,
  isJobActive: PropTypes.bool.isRequired,
  isPortalEmployer: PropTypes.bool.isRequired,
  jobTitle: PropTypes.string.isRequired,
  jobType: PropTypes.string.isRequired,
  keySkills: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.string.isRequired,
  notificationRecipientIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  notificationRecipients: notificationRecipientsType.isRequired,
  postcode: PropTypes.string,
  recruiterFeePercentage: PropTypes.string.isRequired,
  salaryMax: PropTypes.number,
  salaryMin: PropTypes.number.isRequired,
  salaryRange: PropTypes.string,
  salaryType: PropTypes.string.isRequired,
  sectorId: PropTypes.number.isRequired,
  sectorOptions: sectorOptionsType.isRequired,
  step: PropTypes.number,
  updateJobProfile: PropTypes.func.isRequired,
  vacancyReason: PropTypes.number,
  vacancyReasonOptions: vacancyReasonOptionsType.isRequired,
  validate: PropTypes.func.isRequired,
  visaSponsorship: PropTypes.bool.isRequired,
  numberOfPositions: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

EditForm.defaultProps = {
  agencyBriefing: null,
  audienceId: null,
  benefitIds: PropTypes.arrayOf,
  closeJobUrl: null,
  contractDuration: null,
  contractDurationInterval: null,
  copyJobUrl: null,
  interviewComments: null,
  keySkills: null,
  postcode: null,
  salaryMax: null,
  salaryRange: null,
  step: null,
  vacancyReason: null,
  burst: null,
  numberOfPositions: null,
  currencySymbol: null,
};

export default EditForm;
